import { render, staticRenderFns } from "./SeminarEntryMessageHistoryToApplicant.vue?vue&type=template&id=075c5bf5"
import script from "./SeminarEntryMessageHistoryToApplicant.vue?vue&type=script&lang=js"
export * from "./SeminarEntryMessageHistoryToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports